@if (link(); as l) {
    <big-ui-link
        *transloco="let t; prefix: 'uiCard'"
        class="print:hidden flex"
        [class.justify-end]="alignment() === 'right'"
        [href]="l.href"
        [linkClass]="'focus-visible:outline-none no-underline after:absolute after:inset-0 ' + customLinkClass()"
        [srOnly]="hideLink()">
        <div class="flex items-center gap-2">
            <span>
                @if (l.title) {
                    {{ l.title }}
                } @else {
                    {{ t('readMore') }}
                }
            </span>
            <big-icon
                class="fill-current shrink-0"
                [size]="'w-5'"
                [icon]="iconArrowRight" />
        </div>
    </big-ui-link>
}
